//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const HeadcountHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background">

      <Box background="url('/images/hpe-hq-front.jpg')" height="140px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
                        <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                          title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>OneGW - Headcount</Text>} 
                          style={{ color: 'white' }}
                          size='medium'/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Headcount coming soon...</Heading>

      </PageContent>  

    </Page>
  );
};